import { useNavigate, useParams, useLocation } from "react-router-dom";

import AssetVideoDetail from "Components/Shared/AssetVideoDetail";

const DrillVideoDetail = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as {
    currentPage: number;
  };

  const id = Number(params.id);

  if (Number.isNaN(id)) {
    navigate("/page-not-found");
  }

  const handleBackNavigation = () => {
    navigate("/drills", { state: { currentPage: state?.currentPage || 1 } });
  };

  return <AssetVideoDetail videoId={id} onBackClick={handleBackNavigation} />;
};

export default DrillVideoDetail;
